import * as Sentry from '@sentry/nuxt'

export default defineNuxtPlugin((nuxtApp) => {
  const { vueApp } = nuxtApp
  // Apply Vue component tracing mixins
  vueApp.mixin(
    Sentry.createTracingMixins({
      trackComponents: true,
      timeout: 2000,
      hooks: ['activate', 'mount', 'update']
    })
  )

  return {
    provide: {
      sentry: Sentry
    }
  }
})
